/**
 * Editor & Formatting Icons
 * 
 * Icons for markdown editors, text formatting, and rich text controls.
 * 
 * Used by: Markdown editor, text editor, note editing
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBold as fadBold,
  faItalic as fadItalic,
  faStrikethrough as fadStrikethrough,
  faH1 as fadH1,
  faH2 as fadH2,
  faH3 as fadH3,
  faImage as fadImage,
  faQuoteRight as fadQuoteRight,
  faListOl as fadListOl,
  faListUl as fadListUl,
  faList as fadList,
  faSquareCheck as fadSquareCheck,
  faEraser as fadEraser,
  faKeyboard as fadKeyboard,
  faPenToSquare as fadPenToSquare,
  faSignature as fadSignature,
  faBook as fadBook,
  faBookOpen as fadBookOpen,
  faBookmark as fadBookmark,
  faBooks as fadBooks,
  faBookOpenCover as fadBookOpenCover,
  faStickyNote as fadStickyNote,
  faNote as fadNote,
  faNotebook as fadNotebook,
  faQuoteLeft as fadQuoteLeft,
  faClipboard as fadClipboard,
  faClipboardList as fadClipboardList,
  faClipboardQuestion as fadClipboardQuestion,
  faBracketsCurly as fadBracketsCurly,
  faUndo as fadUndo,
  faTh as fadTh,
  faCommentsQuestion as fadCommentsQuestion,
  faToggleOn as fadToggleOn,
  faToggleOff as fadToggleOff,
} from "@fortawesome/pro-duotone-svg-icons";

export const loadEditorIcons = () => {
  library.add(
    fadBold,
    fadItalic,
    fadStrikethrough,
    fadH1,
    fadH2,
    fadH3,
    fadImage,
    fadQuoteRight,
    fadListOl,
    fadListUl,
    fadList,
    fadSquareCheck,
    fadEraser,
    fadKeyboard,
    fadPenToSquare,
    fadSignature,
    fadBook,
    fadBookOpen,
    fadBookmark,
    fadBooks,
    fadBookOpenCover,
    fadStickyNote,
    fadNote,
    fadNotebook,
    fadQuoteLeft,
    fadClipboard,
    fadClipboardList,
    fadClipboardQuestion,
    fadBracketsCurly,
    fadUndo,
    fadTh,
    fadCommentsQuestion,
    fadToggleOn,
    fadToggleOff,
  );
};
